import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";

export const startGuarantee = async (params: stdObject) => {
  const {
    t,
    documentAction,
    setWindowValues,
    guarantees,
    openInnerSelection,
    setMsg,
    setMsg2,
    closeMsg,
    setModalData,
    setModalData2,
  } = params;
  const msgVoidData = {
    title: t("p.askGuaranteeDoc"),
    buttons: [
      {
        label: t("p.accept"),
        onClick: () => {
          closeMsg(2);
          openInnerSelection({
            key: "GAR",
            data: { value: "" },
            value: "",
            itemCode: "",
            t,
            setMsg,
            setWindowValues,
            setModalData,
            tableList: guarantees,
          });
        },
      },
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg();
          closeMsg(2);

          documentAction.current = {};
        },
        color: colors.darkGrey,
      },
    ],
  };
  setMsg2("custom2");
  setModalData2(msgVoidData);
};
